'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADD_TIME_ON_PAGE_TRIGGER = exports.ADD_TIME_ON_PAGE_TRIGGER = 'ADD_TIME_ON_PAGE_TRIGGER';

var REMOVE_TIME_ON_PAGE_TRIGGER = exports.REMOVE_TIME_ON_PAGE_TRIGGER = 'REMOVE_TIME_ON_PAGE_TRIGGER';